import { Chip } from "@mui/material";
import DiamondSharpIcon from '@mui/icons-material/DiamondSharp';
import DiamondOutlinedIcon from '@mui/icons-material/DiamondOutlined';
interface ProChipProps {
  nomargin?: boolean;
  hasRightMargin?: boolean;
  useDiamond?: boolean;
  marginBottom?: string;
}
const ProChip: React.FC<ProChipProps & { height?: string, width?: string, openPage?:boolean, marginBottom?:string }> = ({
  nomargin = false,
  hasRightMargin = false,
  openPage = true,
  useDiamond = false,
  height,
  width,
  marginBottom = "0px"
}) => {
  console.log("ProChip rendered: ", width);
  return (
    <Chip
      label={
        <div className="flex items-center justify-center w-full">
          <span>PRO</span>
          {useDiamond && <DiamondOutlinedIcon sx={{ fontSize: "15px", color: "white", marginLeft: "1px", }} />}
        </div>
      }
      color="primary"
      size="small"
      onClick={openPage ? () => window.open("/pro", "_blank") : null}
      className="ml-[5px]"
      sx={{
        fontWeight: "700",
        borderRadius: 2,
        paddingY: 0,
        marginLeft: nomargin ? "0px" : "5px",
        marginRight: hasRightMargin ? "5px" : "0px",
        marginBottom: marginBottom,
        height: height || undefined,
        width: width == undefined? useDiamond ? "60px" : "45px":width,
        fontSize: "12px",
        "& .MuiChip-label": {
          display: "flex",
          justifyContent: "center",
          width: "100%",
          padding: 0
        }
      }}
    />
  );
};

export default ProChip;
